import React, { useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faX, faSearch, faEdit, faTrash, faToggleOn, faToggleOff,
  faSort, faSortUp, faSortDown, faDownload, faPlus
} from '@fortawesome/free-solid-svg-icons';
import { decryptData } from '../../utils/storageCrypto';

const ViewAssignedProducts = ({ supplier, category, onClose, assignedProducts, onProductUpdate, onProductRemove }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const [editingProduct, setEditingProduct] = useState(null);
  const [editData, setEditData] = useState({});
   const [deleteSupplierProductPoup,setDeleteSupplierProductPoup] = useState(false);
  const [assignedProductId, setAssignedProductId] = useState(null);

    const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  console.log('assignedProducts:', assignedProducts);
  
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES || '';

  // Process the assignedProducts data based on your API response structure
  const processedProducts = useMemo(() => {
    if (!assignedProducts || !Array.isArray(assignedProducts)) {
      return [];
    }
    // Map the products to match the expected structure
    return assignedProducts.map(product => ({
      product_id: product._id || product.product_id,
      product_name: product.product_name,
      product_image: product.product_image,
      specifications: product.specifications,
      original_price: product.selling_price || product.original_price,
      supplier_price: product.vendor_details?.vendor_price || product.supplier_price || product.selling_price,
      SKU_Code: product.vendor_details?.SKU_Code || product.SKU_Code, // Fixed: was vendor_details instead of product.vendor_details
      uom: product.uom,
      is_active: product.vendor_details?.is_active !== undefined ? product.vendor_details.is_active : true,
      moqs: product.vendor_details?.moqs || product.moqs || [],
      assigned_date: new Date().toISOString().split('T')[0], // Default to today if not provided
      priority: product.vendor_details?.priority || 1
    }));
  }, [assignedProducts]);

  const filteredAndSortedProducts = useMemo(() => {
    if (!processedProducts || processedProducts.length === 0) return [];

    let filtered = processedProducts.filter(product =>
      product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (sortConfig.key) {
      filtered.sort((a, b) => {
        let aValue = a[sortConfig.key];
        let bValue = b[sortConfig.key];

        if (sortConfig.key === 'supplier_price' || sortConfig.key === 'original_price') {
          aValue = parseFloat(aValue) || 0;
          bValue = parseFloat(bValue) || 0;
        }

        if (sortConfig.key === 'assigned_date') {
          aValue = new Date(aValue);
          bValue = new Date(bValue);
        }

        if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    return filtered;
  }, [processedProducts, searchTerm, sortConfig]);

  const handleSort = (key) => {
    setSortConfig(prevConfig => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return faSort;
    return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
  };

  const handleEdit = (product) => {
    setEditingProduct(product.product_id);
    setEditData({
      SKU_Code: product.SKU_Code,
      supplier_price: product.supplier_price,
      moqs: [...(product.moqs || [])].map(moq => ({
        min_quantity: moq.min_quantity || moq.quantity || 0,
        max_quantity: moq.max_quantity || null,
        selling_price: moq.selling_price || moq.price || 0
      }))
    });
  };
 
const handleSaveEdit = async () => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);


      if (!token) {
        throw new Error('No authentication token found');
      }

    console.log('Saving edit for product:', editingProduct, editData);
    
    // Get supplier/vendor ID from the supplier prop or from the product data
    const vendorId = supplier?.vendor_id || supplier?._id;
    
    if (!vendorId) {
      throw new Error('Vendor ID not found');
    }
    
    if (!editingProduct) {
      throw new Error('Product ID not found');
    }
    
    const data = {
      vendor_price: editData.supplier_price,
      SKU_Code: editData.SKU_Code,
      moqs: editData.moqs?.map(moq => ({
        min_quantity: moq.min_quantity || null,
        max_quantity: moq.max_quantity || null,
        selling_price: moq.selling_price || null,
        cost_price: moq?.cost_price || null,
      })) || [], // Added fallback to empty array
    };
    
    // Fix the URL - add missing = signs and use correct endpoint
    const response = await fetch(`${fetchUrl}product/update-supplier-product-data?product_id=${editingProduct}&vendor_id=${vendorId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify(data) // Fixed: Added closing parenthesis and removed semicolon
    });
    //console.log('Response from server:', response);
    const result = await response.json();
    //console.log('Response from server:', result);
    
    if (!response.ok) {
      throw new Error(result.message || `HTTP error! status: ${response.status}`);
    }
    
    if (result.success) {
      
      // Call parent component callback if provided - pass the product_id, not the object
      onProductUpdate?.(editingProduct, result.data);
      
      // Show success notification
      console.log('Product updated successfully');
      
    } else {
      throw new Error(result.message || 'Failed to update product');
    }
  } catch (error) {
    console.error('Error saving product edit:', error);
   console.log('Error message:', error.message);
  }finally {
    setEditingProduct(null);
      setEditData({});
  }
};


  const handleCancelEdit = () => {
    setEditingProduct(null);
    setEditData({});
  };

 const handleToggleStatus = async (productId, currentStatus) => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    console.log('Toggling status for product:', productId, 'from', currentStatus);
    
    // Get supplier/vendor ID from the supplier prop or from the product data
    const vendorId = supplier?.vendor_id || supplier?._id;
    
    if (!vendorId) {
      throw new Error('Vendor ID not found');
    }
    
    if (!productId) {
      throw new Error('Product ID not found');
    }
    
    const response = await fetch(`${fetchUrl}product/change-supplier-product-status?product_id=${productId}&vendor_id=${vendorId}`, {
      method: 'PUT', // or 'PATCH' depending on your backend implementation
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify({
        is_active: !currentStatus // Toggle the current status
      })
    });
    
    const result = await response.json();
    console.log('Response from server:', result);
    
    if (!response.ok) {
      throw new Error(result.message || `HTTP error! status: ${response.status}`);
    }
    
    if (result.success) {
      // Call parent component callback if provided to update the UI
      onProductUpdate?.();
      
      // Show success notification
      console.log('Product status updated successfully');
      
      // Optionally show user feedback
      // alert(`Product status ${!currentStatus ? 'activated' : 'deactivated'} successfully!`);
      
    } else {
      throw new Error(result.message || 'Failed to update product status');
    }
    
  } catch (error) {
    console.error('Error toggling product status:', error);
    alert(`Error updating product status: ${error.message}`);
  }
};


  const handleRemoveProduct = async (productId) => {
    setDeleteSupplierProductPoup(true);
    setAssignedProductId(productId);
};

 const ConfirmDelete = async () => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    console.log('Removing product:', assignedProductId);
    
    // Get supplier/vendor ID from the supplier prop or from the product data
    const vendorId = supplier?.vendor_id || supplier?._id;
    
    if (!vendorId) {
      throw new Error('Vendor ID not found');
    }
    
    if (!assignedProductId) {
      throw new Error('Product ID not found');
    }
    
    const response = await fetch(`${fetchUrl}product/delete-supplier-assigned-product?product_id=${assignedProductId}&vendor_id=${vendorId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      }
    });
    
    const result = await response.json();
    console.log('Response from server:', result);
    
    if (!response.ok) {
      throw new Error(result.message || `HTTP error! status: ${response.status}`);
    }
    
    if (result.success) {
      // Call parent component callback to update the UI
      onProductRemove?.(assignedProductId);
      
      // Show success notification
      console.log('Product removed successfully');
      //alert('Product removed from supplier successfully!');
      
      // Close the popup
      setDeleteSupplierProductPoup(false);
      setAssignedProductId(null);
      
    } else {
      throw new Error(result.message || 'Failed to remove product');
    }
    
  } catch (error) {
    console.error('Error removing product:', error);
    console.log('Error message:', error.message);
   // alert(`Error removing product: ${error.message}`);
    // Close popup even on error
    setDeleteSupplierProductPoup(false);
    setAssignedProductId(null);
  }
};

const handleCancelDelete = () => {
  setDeleteSupplierProductPoup(false);
  setAssignedProductId(null);
};

  const addMOQ = () => {
    setEditData(prev => ({
      ...prev,
      moqs: [...(prev.moqs || []), { min_quantity: 0, max_quantity: null, selling_price: 0 }]
    }));
  };

  const removeMOQ = (index) => {
    setEditData(prev => ({
      ...prev,
      moqs: prev.moqs.filter((_, i) => i !== index)
    }));
  };

  const updateMOQ = (index, field, value) => {
    setEditData(prev => ({
      ...prev,
      moqs: prev.moqs.map((moq, i) =>
        i === index
          ? { 
              ...moq, 
              [field]: field === 'min_quantity' || field === 'max_quantity' 
                ? (value === '' || value === null ? null : parseInt(value) || 0)
                : parseFloat(value) || 0 
            }
          : moq
      )
    }));
  };

  const calculateSavings = (originalPrice, supplierPrice) => {
    const original = parseFloat(originalPrice) || 0;
    const supplier = parseFloat(supplierPrice) || 0;
    const savings = original - supplier;
    const percentage = original > 0 ? ((savings / original) * 100).toFixed(1) : 0;
    return { amount: savings, percentage };
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString();
    } catch (error) {
      return dateString;
    }
  };

  const totalProducts = processedProducts.length;
  const activeProducts = processedProducts.filter(p => p.is_active).length;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-[95%] max-w-7xl h-[90vh] flex flex-col">
        {/* Header */}
        <div className="border-b px-6 py-3 flex justify-between items-center">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Assigned Products</h2>
            <p className="text-sm text-gray-600 mt-1">
              Supplier: <span className="font-medium">{supplier?.name || 'N/A'}</span> |
              Category: <span className="font-medium">{category?.product_category_name || 'N/A'}</span>
            </p>
            <div className="flex items-center gap-4 mt-2 text-sm">
              <span className="text-gray-600">Total: <span className="font-medium">{totalProducts}</span></span>
              <span className="text-green-600">Active: <span className="font-medium">{activeProducts}</span></span>
              <span className="text-red-600">Inactive: <span className="font-medium">{totalProducts - activeProducts}</span></span>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <FontAwesomeIcon icon={faX} className="text-lg" />
          </button>
        </div>

        {/* Search and Controls */}
        <div className="border-b px-4 py-3 bg-gray-50">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              <div className="relative">
                <FontAwesomeIcon
                  icon={faSearch}
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"
                />
                <input
                  type="text"
                  placeholder="Search assigned products..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
{/*             <div className="flex items-center gap-2">
              <button className="px-3 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50 flex items-center gap-2">
                <FontAwesomeIcon icon={faDownload} />
                Export
              </button>
            </div> */}
          </div>
        </div>

        {/* Products Table */}
        <div className="flex-1 overflow-auto">
          {filteredAndSortedProducts.length > 0 ? (
            <table className="w-full">
              <thead className="sticky top-0 bg-gray-50 border-b">
                <tr>
                  <th className="text-left py-3 px-4 font-medium text-gray-700">Product</th>
                  <th
                    className="text-left py-3 px-4 font-medium text-gray-700 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort('original_price')}
                  >
                    <div className="flex items-center gap-2">
                      Original Price
                      <FontAwesomeIcon icon={getSortIcon('original_price')} className="text-xs" />
                    </div>
                  </th>
                  <th
                    className="text-left py-3 px-4 font-medium text-gray-700 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort('supplier_price')}
                  >
                    <div className="flex items-center gap-2">
                      Supplier Price
                      <FontAwesomeIcon icon={getSortIcon('supplier_price')} className="text-xs" />
                    </div>
                  </th>
                  <th className="text-left py-3 px-4 font-medium text-gray-700">MOQ</th>
                  {/* <th className="text-left py-3 px-4 font-medium text-gray-700">Status</th> */}
                  <th className="text-left py-3 px-4 font-medium text-gray-700">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {filteredAndSortedProducts.map((product) => {
                  const isEditing = editingProduct === product.product_id;
                  const savings = calculateSavings(product.original_price, product.supplier_price);
                  
                  return (
                    <tr key={product.product_id} className="hover:bg-gray-50">
                      <td className="py-4 px-4">
                        <div className="flex items-center gap-3">
                          <div className="w-12 h-12 bg-gray-200 rounded-lg flex items-center justify-center">
                            {product.product_image ? (
                              <img
                                src={`${imageUrl}${product.product_image}`}
                                alt={product.product_name}
                                className="w-full h-full object-cover rounded-lg"
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                            ) : (
                              <span className="text-gray-400 text-xs">IMG</span>
                            )}
                          </div>
                          <div>
                            <div className="font-medium text-gray-900">{product.product_name}</div>
                            <div className="text-sm text-gray-500">
                              {product.SKU_Code && <span className="ml-2">SKU: {product.SKU_Code}</span>}
                              {product.uom && product.uom.UOM && <span className="ml-2">UOM: {product.uom.UOM}</span>}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="py-4 px-4">
                        <span className="font-medium">₹{parseFloat(product.original_price || 0).toLocaleString()}</span>
                      </td>
                      <td className="py-4 px-4">
                        {isEditing ? (
                          <div className="relative w-24">
                            <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">₹</span>
                            <input
                              type="number"
                              value={editData.supplier_price || ''}
                              onChange={(e) => setEditData(prev => ({ ...prev, supplier_price: parseFloat(e.target.value) || 0 }))}
                              className="pl-6 pr-2 py-1 w-full border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                            />
                                                  </div>
                        ) : (
                          <span className="font-medium text-green-600">₹{parseFloat(product.supplier_price || 0).toLocaleString()}</span>
                        )}
                      </td>
                      <td className="py-4 px-4">
                        {isEditing ? (
                          <div className="space-y-2">
                            {(editData.moqs || []).map((moq, index) => (
                              <div key={index} className="space-y-1">
                                <div className="flex items-center gap-1 text-sm">
                                  <div className="flex flex-col">
                                    <label className="text-xs text-gray-500">Min Qty</label>
                                    <input
                                      type="number"
                                      placeholder="Min"
                                      value={moq.min_quantity || ''}
                                      onChange={(e) => updateMOQ(index, 'min_quantity', e.target.value)}
                                      className="w-16 px-2 py-1 border border-gray-300 rounded text-xs"
                                    />
                                  </div>
                                  <div className="flex flex-col">
                                    <label className="text-xs text-gray-500">Max Qty</label>
                                    <input
                                      type="number"
                                      placeholder="Max"
                                      value={moq.max_quantity || ''}
                                      onChange={(e) => updateMOQ(index, 'max_quantity', e.target.value)}
                                      className="w-16 px-2 py-1 border border-gray-300 rounded text-xs"
                                    />
                                  </div>
                                  <span className="mt-4">@</span>
                                  <div className="flex flex-col">
                                    <label className="text-xs text-gray-500">Price</label>
                                    <div className="relative">
                                      <span className="absolute left-1 top-1/2 transform -translate-y-1/2 text-gray-500 text-xs">₹</span>
                                      <input
                                        type="number"
                                        placeholder="Price"
                                        value={moq.selling_price || ''}
                                        onChange={(e) => updateMOQ(index, 'selling_price', e.target.value)}
                                        className="pl-4 pr-2 py-1 w-20 border border-gray-300 rounded text-xs"
                                      />
                                    </div>
                                  </div>
                                  <button
                                    onClick={() => removeMOQ(index)}
                                    className="text-red-600 hover:text-red-800 text-xs mt-4"
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </div>
                              </div>
                            ))}
                            <button
                              onClick={addMOQ}
                              className="text-blue-600 hover:text-blue-800 text-xs flex items-center gap-1"
                            >
                              <FontAwesomeIcon icon={faPlus} />
                              Add MOQ
                            </button>
                          </div>
                        ) : (
                          <div className="space-y-1">
                            {product.moqs && product.moqs.length > 0 ? (
                              product.moqs.map((moq, index) => (
                                <div key={index} className="text-sm text-gray-600">
                                  {moq.min_quantity || moq.quantity}
                                  {moq.max_quantity && ` - ${moq.max_quantity}`}
                                  {' @ ₹'}
                                  {parseFloat(moq.selling_price || moq.price || 0).toLocaleString()}
                                </div>
                              ))
                            ) : (
                              <span className="text-sm text-gray-400">No MOQ</span>
                            )}
                          </div>
                        )}
                      </td>
                      {/* <td className="py-4 px-4">
                        <button
                          onClick={() => handleToggleStatus(product.product_id, product.is_active)}
                          className={`flex items-center gap-2 text-sm ${
                            product.is_active ? 'text-green-600' : 'text-red-600'
                          }`}
                        >
                          <FontAwesomeIcon
                            icon={product.is_active ? faToggleOn : faToggleOff}
                            className="text-lg"
                          />
                          {product.is_active ? 'Active' : 'Inactive'}
                        </button>
                      </td> */}
                      <td className="py-4 px-4">
                        <div className="flex items-center gap-2">
                          {isEditing ? (
                            <>
                              <button
                                onClick={handleSaveEdit}
                                className="text-green-600 hover:text-green-800 text-sm px-2 py-1 rounded border border-green-300 hover:bg-green-50"
                              >
                                Save
                              </button>
                              <button
                                onClick={handleCancelEdit}
                                className="text-gray-600 hover:text-gray-800 text-sm px-2 py-1 rounded border border-gray-300 hover:bg-gray-50"
                              >
                                Cancel
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                onClick={() => handleEdit(product)}
                                className="text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50"
                                title="Edit product"
                              >
                                <FontAwesomeIcon icon={faEdit} />
                              </button>
                              <button
                                onClick={() => handleRemoveProduct(product.product_id)}
                                className="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50"
                                title="Remove product"
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className="flex items-center justify-center h-64">
              <div className="text-center">
                <div className="text-gray-400 text-4xl mb-4">
                  <FontAwesomeIcon icon={faSearch} />
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">No assigned products found</h3>
                <p className="text-gray-600">
                  {searchTerm
                    ? 'Try adjusting your search criteria'
                    : 'No products have been assigned to this supplier for this category'
                  }
                </p>
                {/* {!searchTerm && (
                  <button
                    className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center gap-2 mx-auto"
                    onClick={() => {
                      // You might want to trigger the assign products modal here
                      console.log('Open assign products modal');
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                    Assign Products
                  </button>
                )} */}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="border-t p-4 bg-gray-50 flex justify-between items-center">
          <div className="text-sm text-gray-600">
            Showing {filteredAndSortedProducts.length} of {totalProducts} assigned products
            {searchTerm && (
              <span className="ml-2 text-blue-600">
                (filtered by "{searchTerm}")
              </span>
            )}
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700"
            >
              Close
            </button>
          </div>
        </div>
      </div>

     {deleteSupplierProductPoup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4">
      <h3 className="text-lg font-semibold mb-4">Confirm Delete</h3>
      <p className="text-gray-600 mb-6">
        Are you sure you want to remove this assigned product from this supplier?
      </p>
      <div className="flex gap-3 justify-end">
        <button
          onClick={handleCancelDelete}
          className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
        >
          No, Cancel
        </button>
        <button
          onClick={ConfirmDelete}
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
        >
           Yes, Remove
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default ViewAssignedProducts;

